import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=2e127272&scoped=true"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"
import style0 from "./CompanyView.vue?vue&type=style&index=0&id=2e127272&prod&scoped=true&lang=css"
import style1 from "./CompanyView.vue?vue&type=style&index=1&id=2e127272&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e127272",
  null
  
)

export default component.exports